import React from "react";
import axios from "axios";
import APIURL from "../../../Main/apiurl";

const create_tax = async (tax) => {
  try {
    let data = {
      name: tax?.name,
      code: tax?.code,
      description: tax?.description,
      taxType: tax?.taxType,
      calculationType: tax?.calculationType,
      rate: tax?.rate,
      applicableOn: tax?.applicableOn,
      taxScope: tax?.taxScope,
      inclusiveType: tax?.inclusiveType,
      taxGroup: tax?.taxGroup,
      isCompound: tax?.isCompound,
      dependsOnTax: tax?.dependsOnTax,
      effectiveFrom: tax?.effectiveFrom,
      validUntil: tax?.validUntil,
      isActive: tax?.isActive,
      category: tax?.category,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(`${APIURL}/create-tax`, data, config);

    if (response?.data?.status_code == 401) {
      localStorage.clear();
      window.location.href = "/signin";
      return response?.data;
    } else {
      return response?.data;
    }
  } catch (error) {
    return error;
  }
};

const update_tax = async (tax) => {
  try {
    let data = {
      id: tax?.id,
      name: tax?.name,
      code: tax?.code,
      description: tax?.description,
      taxType: tax?.taxType,
      calculationType: tax?.calculationType,
      rate: tax?.rate,
      category: tax?.category,
      applicableOn: tax?.applicableOn,
      taxScope: tax?.taxScope,
      inclusiveType: tax?.inclusiveType,
      taxGroup: tax?.taxGroup,
      isCompound: tax?.isCompound,
      dependsOnTax: tax?.dependsOnTax,
      effectiveFrom: tax?.effectiveFrom,
      validUntil: tax?.validUntil,
      isActive: tax?.isActive,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(`${APIURL}/update-tax`, data, config);

    if (response?.data?.status_code == 401) {
      localStorage.clear();
      window.location.href = "/signin";
      return response?.data;
    } else {
      return response?.data;
    }
  } catch (error) {
    return error;
  }
};

const get_tax = async (tax) => {
  try {

    let data = {
      id: tax?.id,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(`${APIURL}/get-tax`, data, config);

    if (response?.data?.status_code == 401) {
      localStorage.clear();
      window.location.href = "/signin";
      return response?.data;
    } else {
      return response?.data;
    }
  } catch (error) {
    return error;
  }
};

const get_all_taxes = async (tax) => {
  try {
    const data = {
      search: tax?.search,
      taxType: tax?.taxType,
      calculationType: tax?.calculationType,
      status: tax?.status,
      page: tax?.page,
      category: tax?.category,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(`${APIURL}/get-all-taxes`, data, config);

    if (response?.data?.status_code == 401) {
      localStorage.clear();
      window.location.href = "/signin";
      return response?.data;
    } else {
      return response?.data;
    }
  } catch (error) {
    return error;
  }
};

const delete_tax = async (tax) => {
  try {
    let data = {
      id: tax?.id,
    };

    const token = localStorage.getItem("user");
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await axios.post(`${APIURL}/delete-tax`, data, config);

    if (response?.data?.status_code == 401) {
      localStorage.clear();
      window.location.href = "/signin";
      return response?.data;
    } else {
      return response?.data;
    }
  } catch (error) {
    return error;
  }
};

export { create_tax, update_tax, get_tax, get_all_taxes, delete_tax };
